// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Kiy5s","name":"Header_name__1z_fD","birthday":"Header_birthday__n6UrV","skeleton":"Header_skeleton__wKIap"};